import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'statusDisplay',
    standalone: false
})
export class StatusDisplayPipe implements PipeTransform {

    transform(value: string): string {
        switch (value) {
            case 'ACTIVE':
                return 'Active';
            case 'UPGRADE_REQUIRED':
                return 'Upgrade Required';
            case 'COMING_SOON':
                return 'Coming Soon';
            case 'HIDDEN':
                return 'Hidden';
            default:
                return value ? value.replace(/_/g, ' ').toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : value;
        }
    }

}